/**
 * Pagination component type definitions
 */

export enum PaginationSize {
  Compact = 'compact',
  Default = 'default',
}

export enum PaginationAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
